import { render, staticRenderFns } from "./MultiPage.vue?vue&type=template&id=be3da9de&"
import script from "./MultiPage.vue?vue&type=script&lang=ts&"
export * from "./MultiPage.vue?vue&type=script&lang=ts&"
import style0 from "./MultiPage.vue?vue&type=style&index=0&id=be3da9de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports